"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterTimeCell = void 0;
const time_field_1 = require("../../../components/time-field/time-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
exports.FilterTimeCell = filter_interval_cell_factory_1.filterIntervalCellFactory(time_field_1.TimeField);
//# sourceMappingURL=filter-time-cell.js.map